export const resultTiers = [
  {
    min: 10,
    max: 16,
    level: 1,
    badgeColor: 'bg-tier-1',
    textColor: 'text-tier-1',
    barColor: 'bg-tier-1',
    badgeText: '🟡 NIVEL 1 — ANSIEDAD LEVE',
    title: 'Tu mente está en alerta',
    description:
      'Tu ansiedad está presente pero aún es manejable. Este es el mejor momento para actuar antes de que escale. Una pequeña acción hoy puede evitar años de sufrimiento mañana.',
    percentage: 25,
    icons: ['🌙', '⚡', '🧘‍♀️'],
  },
  {
    min: 17,
    max: 24,
    level: 2,
    badgeColor: 'bg-tier-2',
    textColor: 'text-tier-2',
    barColor: 'bg-tier-2',
    badgeText: '🟠 NIVEL 2 — ANSIEDAD MODERADA',
    title: 'Tu cuerpo está pidiendo ayuda',
    description:
      'Tu ansiedad ya está afectando tu energía diaria, tu sueño y tus relaciones. No es algo que deba ignorarse. Tienes la capacidad de recuperar tu calma — solo necesitas las herramientas correctas.',
    percentage: 50,
    icons: ['🔋', '😴', '🤝'],
  },
  {
    min: 25,
    max: 32,
    level: 3,
    badgeColor: 'bg-tier-3',
    textColor: 'text-tier-3',
    barColor: 'bg-tier-3',
    badgeText: '🔴 NIVEL 3 — ANSIEDAD ALTA',
    title: 'Llevas demasiado tiempo cargando sola con esto',
    description:
      'Tu puntuación indica que la ansiedad ya controla partes importantes de tu vida. Tu sueño, tus relaciones, tu energía y tu paz mental están siendo afectados. No es tu culpa. Pero sí está en tu poder cambiarlo hoy.',
    percentage: 75,
    icons: ['🌪️', '💔', '📉'],
  },
  {
    min: 33,
    max: 40,
    level: 4,
    badgeColor: 'bg-tier-4',
    textColor: 'text-tier-4',
    barColor: 'bg-tier-4',
    badgeText: '🔴 NIVEL 4 — ANSIEDAD SEVERA',
    title: 'Tu mente llegó a su límite',
    description:
      'Tu puntuación es una señal clara de que necesitas herramientas urgentes. La ansiedad severa no desaparece sola — pero sí puede controlarse con el protocolo correcto. Miles de mujeres en tu situación han encontrado la calma. Tú también puedes.',
    percentage: 100,
    icons: ['🚨', '🆘', '🛑'],
  },
]

export const getTier = (score: number) => {
  return (
    resultTiers.find((t) => score >= t.min && score <= t.max) || resultTiers[0]
  )
}
